import { View } from 'api/views/types';

export interface CustomisationState {
  visible: boolean;
  shared: boolean; // "Saved" or "Shared" view
  views: View<unknown>[] | null;
}

export const initialCustomisationState: CustomisationState = {
  visible: false,
  shared: false,
  views: null,
};
